import React from 'react';
import {
	isCommandMessageAccordion,
	isCommandMessageCarousel,
	isEventMessageSurveyData,
	isCommandMessageSurveyInline,
	isEventMessagePostback,
	isCommandCloseChannel,
	isCommandMessageForm,
	isQuickRepliesMessage,
	isTextMessage,
	isCommandMessageHtml,
	isVoiceMessage,
	isMediaMessage,
	isInfoMessage,
	isCommandMessageIframe,
	IChatMessages,
} from '@enuan/chat__utils';
import { useMessageContext } from './message.context';
import { InvalidMessage } from '../Messages/InvalidMessage';
import { SurveyMessage } from '../Messages/survey/SurveyMessage';
import { QuickRepliesMessage } from '../Messages/quick-replies/QuickRepliesMessage';
import { AccordionMessage } from '../Messages/accordion/AccordionMessage';
import { CarouselMessage } from '../Messages/carousel/CarouselMessage';
import { FormMessage } from '../Messages/form/FormMessage';
import { SummaryMessage } from '../Messages/summary/SummaryMessage';
import { TextMessage } from '../Messages/text/TextMessage';
import { HtmlMessage } from '../Messages/html/HtmlMessage';
import { InfoMessage } from '../Messages/InfoMessage';
import { MediaMessage } from '../Messages/media/MediaMessage';
import { IframeMessage } from '../Messages/iframe/IframeMessage';
import { ClosedMessage } from '../Messages/closed/ClosedMessage';
import { IOptionalMessageProps } from '../UI/Message/Message';

export const MessageHandler = React.forwardRef<
	HTMLDivElement,
	IOptionalMessageProps
>((messageProps, ref) => {
	const { message } = useMessageContext<IChatMessages>();

	if (isInfoMessage(message)) {
		return <InfoMessage ref={ref} {...messageProps} />;
	} else if (isQuickRepliesMessage(message)) {
		return <QuickRepliesMessage ref={ref} {...messageProps} />;
	} else if (isTextMessage(message)) {
		return <TextMessage ref={ref} {...messageProps} />;
	} else if (isCommandMessageHtml(message)) {
		return <HtmlMessage ref={ref} {...messageProps} />;
	} else if (isCommandMessageAccordion(message)) {
		return <AccordionMessage ref={ref} {...messageProps} />;
	} else if (isCommandMessageCarousel(message)) {
		return <CarouselMessage ref={ref} {...messageProps} />;
	} else if (isCommandMessageSurveyInline(message)) {
		return <SurveyMessage ref={ref} {...messageProps} />;
	} else if (isCommandMessageForm(message)) {
		return <FormMessage ref={ref} {...messageProps} />;
	} else if (
		isEventMessageSurveyData(message) ||
		isEventMessagePostback(message)
	) {
		return <SummaryMessage ref={ref} {...messageProps} />;
	} else if (isCommandMessageIframe(message)) {
		return <IframeMessage ref={ref} {...messageProps} />;
	} else if (isMediaMessage(message) || isVoiceMessage(message)) {
		return <MediaMessage ref={ref} {...messageProps} />;
	} else if (isCommandCloseChannel(message)) {
		return <ClosedMessage ref={ref} {...messageProps} />;
	} else {
		return <InvalidMessage ref={ref} {...messageProps} />;
	}
});
